import { doujinItems } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const statusMap: Record<string, string> = {
  已完成: "bg-secondary-100 text-secondary-800",
  筹备中: "bg-accent-100 text-accent-900",
};

export default function Doujin() {
  return (
    <section id="doujin" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="Doujin & Side Stories"
          title="本子与番外：支线内容的构成说明"
          desc="这些条目多为正篇之外的外传、插画与设定整理，篇幅更短、可独立阅读。下面标注了每册的类型、状态与页数，方便你按需要比对选择。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="rounded-lg overflow-hidden border border-background-200 bg-background-100 sticky top-24">
              <div className="w-full h-52 md:h-64">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20flat-lay%20painterly%20illustration%20of%20neatly%20stacked%20illustrated%20booklets%20and%20printed%20zines%20on%20a%20warm%20wooden%20table%2C%20soft%20natural%20light%2C%20muted%20ochre%20and%20brick%20red%20tones%2C%20paper%20texture%2C%20minimal%20calm%20props%2C%20no%20text%2C%20no%20people&width=1000&height=800&seq=doujin-zine-stack-01&orientation=landscape"
                  alt="本子与番外册子示意"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">支线内容怎么挑</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  想补人物背景，从设定资料集看起；喜欢画面表现，选插画本；只想轻松翻几段日常，番外短篇集最合适。
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-800 text-xs whitespace-nowrap">设定补完</span>
                  <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs whitespace-nowrap">独立可读</span>
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs whitespace-nowrap">篇幅短</span>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col gap-4">
            {doujinItems.map((item) => (
              <article
                key={item.title}
                className="p-5 rounded-lg bg-background-100 border border-background-200"
              >
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{item.title}</h3>
                  <span className={`px-2.5 py-1 rounded-full text-xs whitespace-nowrap ${statusMap[item.status] ?? "bg-background-200 text-foreground-700"}`}>
                    {item.status}
                  </span>
                </div>
                <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-price-tag-3-line" />
                    {item.type}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-file-list-3-line" />
                    {item.pages}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}